import httpClient from 'httpClient'
import { getBaseUrls } from 'helpers/baseURLhelper'

const OAUTH_ENDPOINT = '/oauth/token'

// Auth Service
export default {
  getAccessToken: function () {
    return httpClient.post(getBaseUrls('baseApi') + OAUTH_ENDPOINT, null, {
      headers: {
        'Authorization': process.env.BASIC_TOKEN
      },
      params: {
        'grant_type': 'client_credentials'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/index.js